// extracted by mini-css-extract-plugin
export var divider = "_dq-7";
export var itemsToggle = "_dq-8";
export var mergeModal = "_dq-1";
export var optionCard = "_dq-4";
export var radioGroup = "_dq-6";
export var radioOption = "_dq-0";
export var selected = "_dq-5";
export var shipmentOptions = "_dq-2";
export var tableOptions = "_dq-3";